import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorStrength = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m24 3 14.849 6.151L45 24l-6.151 14.849L24 45 9.151 38.849 3 24 9.151 9.151Zm0 7.5c4.2 5.7 9 11.1 9 16.7a9 9 0 0 1-18 0c0-5.6 4.8-11 9-16.7"
	}), /* @__PURE__ */ _jsx("path", { d: "M17.2 25.5h13.6c.1.5.2 1.1.2 1.7a7 7 0 0 1-14 0c0-.6.1-1.2.2-1.7" })]
});
export default SvgColorStrength;
